export const QUIZ_QUESTION_REQUEST = 'QUIZ_QUESTION_REQUEST'
export const QUIZ_QUESTION_SUCCESS = 'QUIZ_QUESTION_SUCCESS'
export const QUIZ_QUESTION_FAILURE = 'QUIZ_QUESTION_FAILURE'
